import { useEffect } from "react";
import { MapPin } from "lucide-react";
import { tr, LANG } from "../lib/i18n";
import { useBranches, usePickedBranch, pickBranch, branchName } from "../lib/branches";

// Top-bar branch selector: "All branches" for owner/admin, otherwise only the user's own branches.
export const BranchSwitcher = () => {
  const { data, multi, branches, seesAll } = useBranches();
  const picked = usePickedBranch();
  useEffect(() => {
    if (!data) return;  // wait for the branch list before correcting the choice
    if (!multi) { if (picked) pickBranch(""); return; }
    const ok = branches.some((b) => b.id === picked);
    if (!seesAll && !ok && branches[0]) pickBranch(branches.length === 1 ? branches[0].id : "");
    else if (picked && !ok && branches.length) pickBranch("");
  }, [data, multi, branches, seesAll, picked]);
  if (!multi) return null;
  return (
    <label className="flex items-center gap-1.5 h-10 px-2 border border-[var(--divider)] bg-white text-sm" data-testid="branch-switcher">
      <MapPin size={15} strokeWidth={1.75} aria-hidden="true" />
      <span className="sr-only">{tr("br.branch")}</span>
      <select value={picked} onChange={(e) => pickBranch(e.target.value)} className="bg-transparent outline-none max-w-[11rem]" data-testid="branch-switcher-select">
        {(seesAll || branches.length > 1) && <option value="">{seesAll ? tr("br.all_branches") : tr("br.my_branches")}</option>}
        {branches.map((b) => <option key={b.id} value={b.id}>{branchName(b, LANG)}</option>)}
      </select>
    </label>
  );
};
